"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flexContentMap = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  between: 'space-between',
  around: 'space-around'
};
exports.flexItemsMap = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  baseline: 'baseline',
  stretch: 'stretch'
};